module.exports = __webpack_public_path__ + "static/media/send-back.5ddde05c.svg";